import { ModuleWithProviders, NgModule } from '@angular/core';
import { EGI_PAGES_SNAPSHOT_CONFIG, EgiRoutes } from './types';
import { provideRouter, RouterConfigOptions, Routes, withHashLocation, withRouterConfig } from '@angular/router';
import { EGI_APP_ID_ROUTE_PARAM } from './constants';
import { EgiPagesSnapshot } from './egi-pages-snapshot';

/**
 * Routeropties die `forRoot` toepast: alle `RouterConfigOptions` plus hash-routing.
 * Bewust smaller dan `ExtraOptions`, zodat er geen optie stil kan wegvallen.
 */
export interface EgiRouterOptions extends RouterConfigOptions {
  useHash?: boolean;
}

@NgModule({
  declarations: [],
  imports: [],
  exports: []
})
export class EgiPageFrameworkModule {
  public static forRoot(
    egiAppRoutes: EgiRoutes,
    homePageId: string,
    additionalRoutes?: Routes,
    options?: EgiRouterOptions
  ): ModuleWithProviders<EgiPageFrameworkModule> {
    let routes: Routes = [
      {
        path: `:${EGI_APP_ID_ROUTE_PARAM}`,
        children: egiAppRoutes
      }
    ];

    if (additionalRoutes) {
      routes = [...additionalRoutes, ...routes];
    }

    const { useHash, ...routerConfig } = options ?? {};

    return {
      ngModule: EgiPageFrameworkModule,
      providers: [
        {
          provide: EGI_PAGES_SNAPSHOT_CONFIG,
          useValue: {
            homePageId
          }
        },
        EgiPagesSnapshot,
        provideRouter(routes, withRouterConfig(routerConfig), ...(useHash ? [withHashLocation()] : []))
      ]
    };
  }
}
